import React from 'react';
import { Box } from '@mui/material';

export default function Footer() {
  return (
    <Box
      color="#6c737d"
      fontSize="12px"
      mt="auto"
      p="100px 0 15px"
      textAlign="center"
    >
      X5 Group &copy; {new Date().getFullYear()}
      <Box component="span" ml="24px">
        Все права защищены
      </Box>
    </Box>
  );
}
